import axios from "axios"
import secureLocalStorage from "react-secure-storage"

// const ConfigUrl = {
//   appurl: "/admin/",
//   apiurl: "https://demoapi.returnfirstinvestment.com/api/v1",
//   imageurl: "https://demoapi.returnfirstinvestment.com/",
// }

const ConfigUrl = {
  appurl: "/",
  apiurl: "https://api.returnfirstinvestment.com/api/v1",
  imageurl: "https://api.returnfirstinvestment.com/",
}

export const axiosbaseurl = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})
axiosbaseurl.interceptors.request.use(
  config => {
    const token = secureLocalStorage.getItem("token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default ConfigUrl
